module.exports = __webpack_public_path__ + "static/img/registration.f7bb0a3.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/registration.svg
// module id = T0lT
// module chunks = 1